module.exports = __webpack_public_path__ + "img/exclamation.206dad74.svg";